import { CustomRenderDisplayHoursByMins } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { VirtualTableListingStateLess } from '../../../../baseComponents/TwinTable/VirtualTableListing'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { TableComponentProps } from '../../../../baseComponents/TwinTable/BaseScreenTable/types'
import useDictMonths from '../../../../utils/hooks/useDictMonths'
import { displayFormatedHourFromMins } from '../../../../utils/globals/date'
import { TimeControlEmployeeJourneyByYearProps } from '../types'
import { timeControlEmployeeMonthYearRowRender } from '../functions'
import { RenderMonthOrTotals } from './Subcomponents'
import { RowData } from '../../../../baseComponents/TwinTable/types'
import { EmployeTTShowPermittedTimeInversedKeys, EmployeeJourneyTyExtended } from '../../../../app/erp/screens/Staff/WorkingCalendarParent/TimeControlEmployeeMonth/types'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { haveModuleBuyed } from '../../../../utils/globals'
import { getModulesBuyed } from '../../../../utils/reducers/getters'

type TableControlYearWorkProps = TableComponentProps & {
    data: TimeControlEmployeeJourneyByYearProps[] | null
    year: number
    showPermittedTime?: EmployeTTShowPermittedTimeInversedKeys
    haveOvertimeHours: boolean
}
const TableControlYearWork: React.FC<TableControlYearWorkProps> = ({ data, year, showPermittedTime, haveOvertimeHours }) => {
    const { t } = useTwinTranslation()
    const { dictMonths } = useDictMonths()
    const permittedTime = showPermittedTime === 'efective_hours' ? true : false
    const haveWorkingCalendarFullModule = haveModuleBuyed(['working_calendar_full'], getModulesBuyed())
    let extraOvertimeColumn: ColumnTableSchema<EmployeeJourneyTyExtended> = []
    let extraAgreementHoursColumn: ColumnTableSchema<EmployeeJourneyTyExtended> = []

    if (haveWorkingCalendarFullModule || haveOvertimeHours) {
        extraOvertimeColumn.push({
            id: 'totalOvertimeMins',
            dataKey: 'totalOvertimeMins',
            label: t('OvertimeShort', 'H. extra'),
            headerClassName: 'flex justify-center items-center',
            className: 'flex justify-center items-center',
            customRender: (parameterValue) => <CustomRenderDisplayHoursByMins value={parameterValue} />,
            width: 100
        },)
    }
    if (data?.[0]?.totalAgreementMins) {
        extraAgreementHoursColumn.push({
            id: 'totalAgreementMins',
            dataKey: 'totalAgreementMins',
            label: t('agreementHoursShort', 'H. Convenio'),
            customRender: (parameterValue, allRowData) => <RenderTotalAgreementHours value={parameterValue} allRowData={allRowData} />,
        },)
    }

    const columns: ColumnTableSchema<TwinDictionary> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('monthHeader', 'Mes'),
            customRender: (parameterValue, allRowData) => <RenderMonthOrTotals value={dictMonths[parameterValue]} {...{ allRowData }} />
        },
        {
            id: permittedTime ? 'totalMinsPermittedWorked' : 'totalMinsWorked',
            dataKey: permittedTime ? 'totalMinsPermittedWorked' : 'totalMinsWorked',
            label: t('workedHours', 'Horas trabajadas'),
            customRender: (parameterValue) => <CustomRenderDisplayHoursByMins value={parameterValue}  />,
        },
        {
            id: 'totalMinsToDo',
            dataKey: 'totalMinsToDo',
            label: t('baseHours', 'Horas base'),
            customRender: (parameterValue, allRowData) => <RenderTotalMinsToDo value={parameterValue} allRowData={allRowData} />,
        },
        ...extraAgreementHoursColumn,
        {
            id: 'totalJustifiedMins',
            dataKey: 'totalJustifiedMins',
            label: t('justifiedHours', 'Horas justificadas'),
            customRender: (parameterValue) => <CustomRenderDisplayHoursByMins value={parameterValue} />,
        },
        ...extraOvertimeColumn,
        {
            id: permittedTime ? 'balancePermittedMinsToDo' : 'balanceMinsToDo',
            dataKey: permittedTime ? 'balancePermittedMinsToDo' : 'balanceMinsToDo',
            label: t('balance', 'Balance'),
            headerClassName: 'flex justify-center items-center',
            className: 'flex justify-center items-center',
            customRender: (parameterValue, allRowData) => <RenderTotalMonthBalanceHours balance={parseFloat(parameterValue)} year={year} month={allRowData.id} allRowData={allRowData} permittedTime={permittedTime}/>,
        },
    ]
    return (
        <div className={'flex flex-col flex-auto h-1'}>
            <div className='flex-auto'>
                <VirtualTableListingStateLess columns={columns} setSelectedColumnsAndFilters={() => { }} tableData={data || []} rowHeight={48} headerHeight={48} name='yearWorkDays' rowRenderer={timeControlEmployeeMonthYearRowRender} />
            </div>
        </div>
    )
}

interface RenderTotalMonthBalanceHoursProps {
    year: number
    month: number
    balance: number
    allRowData: RowData
    permittedTime: boolean
}

const RenderTotalMonthBalanceHours: React.FC<RenderTotalMonthBalanceHoursProps> = ({ year, month, balance, allRowData, permittedTime }) => {
    const now = new Date()
    const thisStartMonth = new Date(now.getFullYear(), now.getMonth(), 1)
    const startMonthDate = new Date(year, month - 1, 1)
    if (startMonthDate > thisStartMonth) {
        return <div></div>
    } 
    let balanceClassName = 'flex rounded-xl px-15 py-8 w-80 justify-center ' + (balance === 0 ? 'balance_correct' : balance > 0 ? 'balance_more_hours' : 'balance_less_hours')
    if (allRowData.type === 'totals') {
        balance = (permittedTime ? allRowData?.balancePermittedMinsToDo : allRowData?.balanceMinsToDo) || 0
        balanceClassName = 'balance_total ' + (balance > 0 ? 'balance_total_more_hours' : balance < 0 ? 'balance_total_less_hours' : '')
    }
    return (
        <div className={balanceClassName}>
            {displayFormatedHourFromMins(balance)}
        </div>
    )
}
interface RenderTotalMinsToDoProps {
    value: string
    allRowData: RowData
    className?: string
}

const RenderTotalMinsToDo: React.FC<RenderTotalMinsToDoProps> = ({ allRowData, value, className }) => {
    if (allRowData.type === 'totals' && allRowData.restAgreementMins && !allRowData.totalAgreementMins) {
        return <RenderTotalAgreementHours value={value} allRowData={allRowData} className={className} />
    } else {
        return <CustomRenderDisplayHoursByMins value={value} />
    }
}
interface RenderTotalAgreementHoursProps {
    value: string
    allRowData: RowData
    className?: string
}

const RenderTotalAgreementHours: React.FC<RenderTotalAgreementHoursProps> = ({ allRowData, value, className }) => {
    if (allRowData.type === 'totals') {
        const restAgreementMins = allRowData.restAgreementMins ? displayFormatedHourFromMins(parseInt(String(allRowData.restAgreementMins))) : ''
        const operator = parseInt(String(allRowData.restAgreementMins)) <= 0 ? '' : '+'
        return (
            <span className={className}>{displayFormatedHourFromMins(parseInt(value))} {operator} {restAgreementMins}</span>
        )
    }
    return null
}

export default TableControlYearWork